var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('TopPaper'),_c('AboutContents'),_c('BaseFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }